import React from 'react';
import { t } from '../utils/i18n';

export default function Footer() {
  return (
    <footer className="bg-dark-bg py-6 sm:py-8 border-t border-dark-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-sm sm:text-base text-dark-text-secondary text-center">
          {t('footer.copyright')}
        </p>
      </div>
    </footer>
  );
}
